import React from 'react'
import { Link } from 'react-router-dom'
import { firestoreConnect } from 'react-redux-firebase'
import { connect, useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'
import { EmojiButton } from '../../components/ReactionIcons'

import { getUsers } from '../../store/actions/apiActions'
import Loading from '../../components/Loading'
import AnimationLayout from '../../components/AnimationLayout'

import moment from 'moment'
import 'moment/locale/pt'
moment.locale('pt')

const mainDashLinks = [
    ['Lista de jogadores', 'lista-de-utilizadores', 'menu-social'],
    ['Conselhos de viajantes', 'conselhos', 'menu-social'],
]

const SocialHub = ({ notifications }) => {

    const dispatch = useDispatch()
    const getReactionItems = useSelector(state => state.firebase.profile.reactionItems)
    const updatingReaction = useSelector(state => state.apiCalls.updatingReactions)

    return (
        <AnimationLayout>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6 md:gap-8 lg:gap-12 mb-10">
                {mainDashLinks.map((item, index) =>
                    <Link key={index} to={`comunidade/${item[1]}`}
                        onClick={() => { item[0] === 'Lista de Utilizadores' && dispatch(getUsers('initial', null, null, null, null, 12)) }}
                        className="image-button usable w-full flex flex-col items-center justify-center"
                    >
                        <img alt={item[0]} className='object-contain' src={`${require(`../../assets/img/${item[2]}.png`)}`} />
                        <h2>{item[0]}</h2>
                    </Link>
                )}
            </div>
            <h3 className='w-100 p-3'>Atividade Recente dos Jogadores</h3>
            <ul className='d-inline'>
                {!notifications || updatingReaction ? <Loading />
                    : notifications.length === 0 ? <h4>Parece que não existe qualquer actividade recente na BD...</h4>
                        : notifications.map((item, index) => {
                            let didUserReact = getReactionItems.find(reaction => reaction.id === item.id && reaction.type === 'notifications')
                            let reactionsArray = Object.entries(item.reactions)
                            reactionsArray.sort((a, b) => {
                                console.log(a, b)
                                console.log(a[0])
                                return a[0] > b[0]
                            })

                            return (
                                <div key={index}>
                                    <li className='grid grid-cols-12 gap-6 lg:gap-8 py-2'>
                                        <Link className='col-span-3 lg:col-span-2 flex justify-center items-center' to={`perfil/utilizadores/${item.link}`}>
                                            <img
                                                alt={item.user}
                                                className='avatar-rounded mr-6'
                                                src={require(`../../assets/img/matilde-faces/${item.avatar}.png`)}
                                            />
                                        </Link>
                                        <div className='col-span-9 lg:col-span-6'>
                                            <h5 className='pb-0'>{item.user} - {moment(item.time.toDate()).fromNow()}</h5>
                                            <p>{item.content}</p>
                                        </div>
                                        <div className='col-span-12 lg:col-span-4 grid grid-cols-4 w-full md:w-auto pt-3 sm:pt-0 gap-4 justify-center items-center'>
                                            {reactionsArray.map((reactionItem, index) => {
                                                let activeEmoji = null

                                                if (didUserReact) {
                                                    activeEmoji = didUserReact?.reaction === reactionItem[0] ? true : null
                                                }

                                                return (
                                                    <EmojiButton
                                                        key={index}
                                                        item={item}
                                                        type='notifications'
                                                        isActive={activeEmoji}
                                                        activeItem={didUserReact}
                                                        label={reactionItem[0]}
                                                        number={reactionItem[1]}
                                                        symbol={reactionItem[0]}
                                                    />
                                                )
                                            }
                                            )}
                                        </div>
                                    </li>
                                    <hr className='my-4 h-1 bg-gray-400' />
                                </div>
                            )
                        })}
            </ul>
        </AnimationLayout>
    )
}

export default compose(
    firestoreConnect([
        { collection: 'notifications', orderBy: ['time', 'desc'], limit: 5 }
    ]),
    connect((state, props) => ({
        notifications: state.firestore.ordered.notifications
    }))
)(SocialHub)

